export default {
	title: "Ruleta de la Suerte",
	Lucky: "Suerte",
	wheels: "Ruletas",
	winningrecord: "Registro de Ganadores",
	ActivityRules: "Reglas de la Actividad",
	ActivityRulesContent:
		"Para más información sobre el sorteo, por favor contacte a nuestro servicio de atención al cliente.",
	award: {
		title: "¡Felicidades por ganar!",
		btn: "Recibir premio"
	},
	noticeItem: "{0} ha obtenido {1}",
	lotteryDraws: "{0} sorteos de lotería",
	noAvailableTimes: "Intentos insuficientes disponibles. Por favor, contacte al servicio de atención al cliente.",
	noOpen: "Aún no está abierto",
	noWinning: "Sigue intentándolo",
	ViewALlPrizes: "Ver todos los premios",
	myPrizes: "Mis premios",
	share: "Compartir con un amigo"
};
